import React from 'react';
import { Users, BookOpen, Gift, Star } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <Users className="w-5 h-5 text-emerald-400" data-id="element-286" />,
    text: '+1.500 argentinos'
  }, {
    icon: <BookOpen className="w-5 h-5 text-emerald-400" data-id="element-287" />,
    text: '6 Tomos completos'
  }, {
    icon: <Gift className="w-5 h-5 text-emerald-400" data-id="element-288" />,
    text: '4 Bonus incluidos'
  }, {
    icon: <Star className="w-5 h-5 text-emerald-400 fill-emerald-400" data-id="element-289" />,
    text: '4.9/5 calificación ⭐'
  }];
  return <div className="bg-zinc-900 border-y border-emerald-900/40 py-6" data-id="element-290">
      <div className="container mx-auto px-4" data-id="element-291">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 md:justify-between items-center max-w-5xl mx-auto" data-id="element-292">
          {stats.map((stat, i) => <div key={i} className="flex items-center gap-2 font-medium text-zinc-100" data-id="element-293">
              {stat.icon}
              <span data-id="element-294">{stat.text}</span>
            </div>)}
        </div>
      </div>
    </div>;
}